import moment from 'moment'
import { DataObject } from 'src/models/DataObject'
import { Author } from 'src/models/Author'
import { formatDateToPST } from 'src/utils/format'
import { Rubric } from 'src/models/Rubric'
import { sharedDataStore } from 'src/store/DataStore'

class CallFilters extends DataObject {
  static OVERRIDE_MAPPINGS = {
    callDateRange: ({ callDateRange }) =>
      (callDateRange || []).map((dateStr) => (dateStr ? moment(dateStr) : undefined)),
  }
  groupIds?: string[]
  callDateRange?: Array<moment.Moment | undefined>
  stages?: string[]
}

export class Scorecard extends DataObject {
  static apiEndpoint = '/feed/scorecard/'
  static OVERRIDE_MAPPINGS = {
    author: ({ author }) => (author ? Author.fromData(author) : new Author()),
    rubric: ({ rubric }) => (rubric ? Rubric.fromData(rubric) : new Rubric()),
    callFilters: ({ callFilters }) => (callFilters ? CallFilters.fromData(callFilters) : new CallFilters()),
  }

  title: string
  author: Author
  description: string
  callFilters: CallFilters
  rubric: Rubric
  isActive: boolean
  createdAt: moment.Moment
  lastUpdated: moment.Moment

  canEdit = () =>
    !!this.author?.id && (sharedDataStore.user.id === this.author.id || sharedDataStore.user.isFaasAdminOrManager())

  save(
    this: any,
    newData?: Record<string, any>,
    updateObject?: boolean,
    partial?: boolean,
    options?: Object,
    invalidateCache?: boolean
  ): Promise<any> {
    if (newData && 'callFilters' in newData && 'callDateRange' in newData.callFilters) {
      const callDateRange = newData.callFilters.callDateRange
      if (Array.isArray(callDateRange)) {
        newData.callFilters.callDateRange = callDateRange.map((date) => (date ? formatDateToPST(date) : null))
      }
    }
    if (newData && 'rubric' in newData && 'id' in newData.rubric) {
      newData.rubricId = newData.rubric.id
      delete newData.rubric
    }
    return super.save(newData, updateObject, partial, options, invalidateCache)
  }
}
